/* Sauvé shipping estimate. Preserve the previous Mon–Sat calendar; exclude CO holidays.
   Informational only: never changes cart, inventory, checkout, rates or order attributes. */
(function () {
  'use strict';
  const DAY = 86400000;
  const cache = new Map();
  const iso = date => date.toISOString().slice(0, 10);
  const shift = (date, days) => new Date(date.getTime() + days * DAY);
  const monday = date => shift(date, (8 - date.getUTCDay()) % 7);
  function easter(year) {
    const a = year % 19, b = Math.floor(year / 100), c = year % 100;
    const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451), n = h + l - 7 * m + 114;
    return new Date(Date.UTC(year, Math.floor(n / 31) - 1, n % 31 + 1, 12));
  }
  function holidays(year) {
    if (cache.has(year)) return cache.get(year);
    const result = new Set();
    const date = (month, day) => new Date(Date.UTC(year, month - 1, day, 12));
    [[1,1],[5,1],[7,20],[8,7],[12,8],[12,25]].forEach(([m,d]) => result.add(iso(date(m,d))));
    [[1,6],[3,19],[6,29],[8,15],[10,12],[11,1],[11,11]].forEach(([m,d]) => result.add(iso(monday(date(m,d)))));
    if (year >= 2026) result.add(iso(monday(date(7,9)))); // Ley 2578 de 2026, artículo 6.
    const pascua = easter(year);
    [-3,-2,43,64,71].forEach(days => result.add(iso(shift(pascua,days))));
    cache.set(year,result); return result;
  }
  function bogotaDate(instant = new Date()) {
    const parts = new Intl.DateTimeFormat('en-CA', {timeZone:'America/Bogota',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(instant);
    const value = type => Number(parts.find(p => p.type === type).value);
    return new Date(Date.UTC(value('year'), value('month') - 1, value('day'), 12));
  }
  function addBusinessDays(start, count) {
    if (!Number.isInteger(count) || count < 0 || count > 40) throw new RangeError('Invalid business-day count');
    let date = new Date(start.getTime()), added = 0;
    while (added < count) {
      date = shift(date,1);
      if (date.getUTCDay() !== 0 && !holidays(date.getUTCFullYear()).has(iso(date))) added++;
    }
    return date;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {iso, holidays, bogotaDate, addBusinessDays};
  if (typeof window === 'undefined' || !window.customElements || customElements.get('sauve-delivery-estimate')) return;
  const fmt = date => new Intl.DateTimeFormat('es-CO',{day:'numeric',month:'long',timeZone:'UTC'}).format(date);
  class SauveDeliveryEstimate extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      document.addEventListener('visibilitychange', () => { if (!document.hidden) this.refresh(); }, options);
      window.addEventListener('pageshow', () => this.refresh(), options);
      document.addEventListener('cart:update', () => requestAnimationFrame(() => { if (this.isConnected) this.refresh(); }), options);
      document.addEventListener('variant:update', event => {
        if (this.dataset.productId && String(event.detail?.data?.productId) === this.dataset.productId) {
          this.dataset.available = String(event.detail?.resource?.available === true); this.refresh();
        }
      }, options);
      this.refresh();
    }
    disconnectedCallback() { this.abort?.abort(); clearTimeout(this.timer); }
    refresh() {
      const output = this.querySelector('[data-delivery-date]');
      if (!output) return;
      const available = this.dataset.available !== 'false';
      const domestic = this.dataset.country === 'CO';
      const today = bogotaDate();
      if (available && domestic) {
        const first = addBusinessDays(today,3), last = addBusinessDays(today,5);
        const range = first.getUTCMonth() === last.getUTCMonth() && first.getUTCFullYear() === last.getUTCFullYear()
          ? `${first.getUTCDate()}–${fmt(last)}` : `${fmt(first)} – ${fmt(last)}`;
        const text = `Entrega estimada: ${range.replace('–', '\u2060–\u2060')}`;
        if (output.textContent !== text) output.textContent = text;
        this.dataset.etaStart = iso(first); this.dataset.etaEnd = iso(last); this.dataset.etaToday = iso(today);
      } else {
        output.textContent = !available ? 'Fecha de entrega sujeta a disponibilidad' : 'Tiempo y costo según destino';
        delete this.dataset.etaStart; delete this.dataset.etaEnd; delete this.dataset.etaToday;
      }
      this.dataset.ready = 'true';
      clearTimeout(this.timer);
      // Next midnight in Bogota (UTC−05), also refreshed on browser/tab restoration.
      const nextMidnight = Date.UTC(today.getUTCFullYear(),today.getUTCMonth(),today.getUTCDate()+1,5);
      this.timer = setTimeout(() => this.refresh(), Math.max(1000,nextMidnight-Date.now()+100));
    }
  }
  customElements.define('sauve-delivery-estimate',SauveDeliveryEstimate);
})();
